import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';

@Injectable({
  providedIn: 'root'
})

export class AmazonCardService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultAmazon/";

  constructor(private http: HttpClient) { }

  public getDataTable(data: any, idType): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + idType, data);
  }

  public getDataTableAdmin(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableAdmin', data);
  }

  public getDataTableAdminDsp(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableAdmin?idType=2', data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public loadAmazonFile(data: FormData, idType: number): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'LoadAmazonFile/' + idType, data);
  }

  downloadAmazonExcel(id: string): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetAmazonExcel/' + id;
    return this.http.get<Blob>(endpoint, requestOptions);
  }

  downloadAmazonExcelDsp(id: string): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetAmazonExcel/' + id + '?useDni=true';
    return this.http.get<Blob>(endpoint, requestOptions);
  }

  public RenaultAmazonCardAnimationType(): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + 'RenaultAmazonCardAnimationType');
  }

  public GetUserHasDspCard(): Observable<boolean> {
    return this.http.get<boolean>(this.pathAPI + this.controller + 'GetUserHasDspCard');
  }

  public CheckConditionsDspDistributor(): Observable<boolean> {
    return this.http.get<boolean>(this.pathAPI + this.controller + 'CheckConditionsDspDistributor');
  }

  public SetConditionsDspDistributor(): Observable<boolean> {
    return this.http.get<boolean>(this.pathAPI + this.controller + 'SetConditionsDspDistributor');
  }
}